import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://api.ipify.org',
});

export default instance;
